import { API, graphqlOperation, Storage } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import EquipmentDocumentForm from "components/equipments/documents/EquipmentDocumentForm";
import { updateEquipmentDocument } from "graphql/mutations";
import { getEquipmentDocument } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const EquipmentDocumentUpdateForm = ({ equipmentDocumentId, onSuccess }) => {
  const navigate = useNavigate();
  const [equipmentDocument, setEquipmentDocument] = useState();
  const [loading, setLoading] = useState(false);

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { fileName, fileSrc: fileObj } = valuesParam;
      let fileSrc = equipmentDocument.fileSrc;

      if (fileObj !== equipmentDocument.fileSrc) {
        fileSrc = `${fileObj.name
          .split(".")
          .slice(0, -1)
          .join(".")}_${Date.now()}.${fileObj.name.split(".").slice(-1)[0]}`;

        await Storage.put(`equipments/${fileSrc}`, fileObj, {
          contentType: fileObj.type,
          level: "public",
        });

        await Storage.remove(`equipments/${equipmentDocument.fileSrc}`, {
          level: "public",
        });
      }

      await API.graphql({
        query: updateEquipmentDocument.replaceAll("__typename", ""),
        variables: {
          input: {
            id: equipmentDocumentId,
            fileName,
            fileSrc,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/equipments");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchEquipmentDocument(id) {
    try {
      const equipmentDocumentData = await API.graphql(
        graphqlOperation(getEquipmentDocument, { id })
      );
      const equipmentDocumentItem =
        equipmentDocumentData.data.getEquipmentDocument;
      if (!equipmentDocumentItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/equipments");
        return;
      }
      setEquipmentDocument({
        ...equipmentDocumentItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchEquipmentDocument(equipmentDocumentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentDocumentId]);

  if (!equipmentDocument) return <Loader />;

  return (
    <div>
      <EquipmentDocumentForm
        onSubmit={onSubmit}
        type="update"
        initialValues={equipmentDocument}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Documento de Equipo",
    successUpdated: "Documento de Equipo actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el documento de equipo",
    },
  },
});

export default EquipmentDocumentUpdateForm;
